exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-holder[data-v-642244ae] {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 10px;\n}\n.btn-holder button[data-v-642244ae]:not(:first-child) {\n    margin-left: 20px;\n}\n", ""]);

// exports
